import type { CollectionMarketType } from '@graphql/reactQuery';

export function collectionVerbForActivityTypes(collectionTypes: Set<CollectionMarketType>) {
  const isPrimaryOrAirdropButNotSecondary =
    (collectionTypes.has('PRIMARY_SALE') || collectionTypes.has('AIRDROP')) &&
    !collectionTypes.has('SECONDARY_SALE');
  const isSecondaryOnly = collectionTypes.size === 1 && collectionTypes.has('SECONDARY_SALE');
  const isSecondaryAndBondingCurve =
    collectionTypes.size === 2 &&
    collectionTypes.has('SECONDARY_SALE') &&
    collectionTypes.has('BONDING_CURVE_SALE');
  const isBondingCurveOnly =
    collectionTypes.size === 1 && collectionTypes.has('BONDING_CURVE_SALE');

  if (isPrimaryOrAirdropButNotSecondary || isBondingCurveOnly) {
    return 'minted';
  } else if (isSecondaryOnly || isSecondaryAndBondingCurve) {
    return 'purchased';
  }

  return 'collected';
}
